import {Toast, Tooltip} from './_bootstrap';

(function () {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll('.toast')
    .forEach((toastElement) => new Toast(toastElement));
})();

(function ($) {
  $("#search-button, #search-block-form > .close").click(function (e) {
    let searchBlock = $(".header__search");
    if ($(searchBlock).is(":visible")) {
      searchBlock.hide("fast");
    } else {
      searchBlock.show("fast");
    }
  });
}(jQuery));

(function ($) {
  if (document.getElementsByClassName("field-name-field-uppspr-simply-bookme").length == 1) {
    var el = "<div class='hero__button hero__button_btn'><span class='btn-title'>Bóka</span></div>";
    $(".field-name-field-uppspr-simply-bookme").prepend(el);
    $(".hero__button span").on("click", function () {
      $(".field-name-field-uppspr-simply-bookme").toggleClass("show");
      if ($(".field-name-field-uppspr-simply-bookme").hasClass("show")) {
        $(".field-name-field-uppspr-simply-bookme .hero__button span").text("Loka");
      } else if (!$(".field-name-field-uppspr-simply-bookme").hasClass("show")) {
        $(".field-name-field-uppspr-simply-bookme .hero__button span").text("Bóka");
      }
    });
  }
}(jQuery));

(function ($){
  Drupal.behaviors.filter_click_events = {
    attach: function (context, settings) {
      let formElement =  $('#views-exposed-form-frontpage-block-1');
      $('#exposedFilterMobileSwitcher .category-filter').on('click', function() {
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
          $(this).children('h3').text('Loka');
          $(this).children('.filter__icon').hide();
          if ($('form#views-exposed-form-frontpage-block-1 > fieldset > .fieldset-wrapper > .form-checkboxes > .form-item > input[type="checkbox"]').filter(':checked').length > 0) {
            formElement.addClass("show-button");
          }
        } else {
          $(this).children('h3').text('Flokkar');
          $(this).children('.filter__icon').show();
          formElement.removeClass("show-button");
        }
        formElement.toggleClass('show');
      });

      once('click_on_checkbox', $("form#views-exposed-form-frontpage-block-1 div.js-form-item.form-check"), context).forEach(function (value, index, array) {
        $(value).on('click', function(e) {
          if (formElement.hasClass('show')) {
            formElement.addClass("show-button");
          }
        });
      });

      $(window).on('resize', (e) => {
        if (window.innerWidth > 1130) {

        }
      })
    }
  }
}(jQuery));

(function ($) {
  Drupal.behaviors.filter_events = {
    attach: function (context, settings) {

      once('click_on_legend', $(".views-exposed-form > form#views-exposed-form-frontpage-block-1 > fieldset legend"), context).forEach(function (value, index, array) {
        $(value).on('click', function(e) {
          if (!$('form#views-exposed-form-frontpage-block-1').hasClass('show')) {
            $(this).parent().toggleClass("arrow-up");
            $(this).parent().children(".fieldset-wrapper").toggleClass("min-height");
          }

          $(this).parent().parent().addClass("show-button");
        });
      });

      once('click_on_fieldset_wrapper', $(".views-exposed-form > form#views-exposed-form-frontpage-block-1 > fieldset.fieldgroup > .fieldset-wrapper"), context).forEach(function (value, index, array) {
        $(value).on('click', function(e) {
          if (!$('form#views-exposed-form-frontpage-block-1').hasClass('show')) {
            $(this).parent().toggleClass("arrow-up");
            $(this).toggleClass("min-height");
          }
        });
      });

      let counter = once('filter_event', 'form#views-exposed-form-frontpage-block-1 fieldset > legend', context);
      $('<span></span>').appendTo(counter);

      [1,2,3,4].forEach((val, index) => {
        let checkboxElements = $('form#views-exposed-form-frontpage-block-1 > fieldset:nth-child(' + val + ') > .fieldset-wrapper > .form-checkboxes > .form-item > input[type="checkbox"]')
        checkboxElements.change(function () {
          let countCheckedCheckboxes = checkboxElements.filter(':checked').length;
          let element = $('form#views-exposed-form-frontpage-block-1 > fieldset:nth-child(' + val + ') > legend > span:first-child');
          countCheckedCheckboxes === 0 ? element.text('') : element.text(' ('+ countCheckedCheckboxes +')');
        })
      })
    }
  };
}(jQuery));
